import { render, staticRenderFns } from "./SentencePreviewArrow.vue?vue&type=template&id=38261a92&"
var script = {}
import style0 from "./SentencePreviewArrow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports